import { useQuery } from 'react-query'
import { BASE_API_URL } from 'constants/env'
import { API_METHODS } from 'constants/api-methods'
import { apiHeaders } from 'utils/api-headers'
import { store } from 'index'
import { handleErrors } from 'utils/handle-errors'

interface GHLUser {
  id: string
  name: string
  email: string
  firstName?: string
  lastName?: string
  phone?: string
  deleted?: boolean
  permissions?: {
    contactsEnabled?: boolean
    conversationsEnabled?: boolean
    campaignsEnabled?: boolean
    appointmentsEnabled?: boolean
    funnelsEnabled?: boolean
    workflowsEnabled?: boolean
    paymentsEnabled?: boolean
    reportingEnabled?: boolean
  }
  roles?: {
    type?: string
    role?: string
    locationIds?: string[]
    restrictSubAccount?: boolean
  }
}

interface OrganizationUser {
  id: string
  name: string
  email: string
  phone_number?: string
}

interface GHLUserMappingsResponse {
  data: {
    ghl_users: GHLUser[]
    organization_users: OrganizationUser[]
    mappings: Record<string, string>
  }
}

const fetchGHLUserMappings = async (
  orgId: string,
  integrationConnectionId: number
) => {
  try {
    let response = await fetch(
      `${BASE_API_URL}/admin/api/v2/organizations/${orgId}/integrations/ghl_user_mappings?integration_connection_id=${integrationConnectionId}`,
      {
        method: API_METHODS.GET,
        headers: apiHeaders(store.getState()),
      }
    )
    response = handleErrors(response)
    const json: GHLUserMappingsResponse = await response.json()
    return json.data
  } catch (error) {
    console.error('Error fetching GHL user mappings:', error)
    throw error
  }
}

export const useGHLUserMappings = (
  orgId: string,
  integrationConnectionId: number | null,
  enabled: boolean = true
) => {
  return useQuery(
    ['ghl-user-mappings', orgId, integrationConnectionId],
    () => fetchGHLUserMappings(orgId, integrationConnectionId!),
    {
      enabled: enabled && !!orgId && !!integrationConnectionId,
    }
  )
}

export type { GHLUser, OrganizationUser }
